import { PeticaoArea } from '@app/models/peticao-area.model';
import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';

import { PeticaoAreaService } from '@app/services/peticao-area.service';
import { CDSMask } from '@app/utils/cds-mask';
import { Router, ActivatedRoute } from '@angular/router';
import { PeticaoService } from '@app/services/peticao.service';
import { Peticao } from '@app/models/peticao';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { GerarDoc } from '@app/models/gerardoc.model';
import { ProcessoGerarDocService } from '@app/services/processo-gerardoc.service';

// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


@Component({
  selector: 'app-peticao-form',
  templateUrl: './gerardoc-form.component.html',
  styleUrls: ['./gerardoc-form.component.scss']
})
export class GerarDocFormComponent implements OnInit {

  gerarDoc: GerarDoc = new GerarDoc();
  titulo: string;
  lstErros: string[];
  cdsMask = new CDSMask();
  tags: any;
  entrevistaSelecionada: any;
  processoId: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoGerarDocService: ProcessoGerarDocService,
    @Inject(ToastrService) public toastr: ToastrService,
    private utilitarioService: UtilitarioService
  ) {
  }

  ngOnInit() {

    this.route.parent.params.subscribe(params => {
      this.processoId = params['id'];
    });

    const id = this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar documento' : 'Novo documento';

      // novo
      if (!id) {
        // this.peticao.Ativo = true;
      } else {
        // editar
        this.processoGerarDocService.obterPorId(id).toPromise().then(
          data => this.gerarDoc = data,
          () => this.router.navigate(['./processos/processo/', this.processoId, 'gerardoc'])
        );
      }
    });

    this.processoGerarDocService.obterPorTags(0).toPromise().then(data => this.tags = data);
  }

  alteraArquivoMasculino(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.gerarDoc.ArquivoMasculino = fileInput.target.files[0];
    }

  }

  alteraArquivoFeminino(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.gerarDoc.ArquivoFeminino = fileInput.target.files[0];
    }

  }

  // alteraArquivo(fileInput: any, sexo: boolean) {
  //   if (fileInput.target.files && fileInput.target.files[0]) {
  //     this.gerarDoc.File = fileInput.target.files[0];
  //   }

  //   this.sexoMasculino = sexo;
  // }



  onSubmit() {
    if (this.gerarDoc.Id === 0) {
      const dados = UtilitarioService.convertModelToFormData(this.gerarDoc);

      this.processoGerarDocService.adicionar(dados)
        .toPromise().then(
          () => this.router.navigate(['./processos/processo/', this.processoId, 'gerardoc']),
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          });
    } else {
      const dados = UtilitarioService.convertModelToFormData(this.gerarDoc);
      this.processoGerarDocService.alterar(dados)
        .toPromise().then(
          () => this.router.navigate(['./processos/processo/', this.processoId, 'gerardoc']),
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          });
    }
  }

  public obterArquivoMasculino() {
    this.processoGerarDocService.obterArquivo(this.gerarDoc.Id, "M").subscribe((data) => {
      this.downloadArquivo(data, this.gerarDoc.Nome + this.gerarDoc.Extensao);
      setTimeout(() => this.toastr.success("Modelo baixado", "Ok"), 250);
    }, () => {
      this.toastr.error("Ocorreu um erro!");
    });
  }


  public obterArquivoFeminino() {
    this.processoGerarDocService.obterArquivo(this.gerarDoc.Id, "F").subscribe((data) => {
      this.downloadArquivo(data, this.gerarDoc.Nome + this.gerarDoc.Extensao);
      setTimeout(() => this.toastr.success("Modelo baixado", "Ok"), 250);
    }, () => {
        this.toastr.error("Ocorreu um erro!");
    });
  }

  downloadArquivo(blob, fileName) {
    this.utilitarioService.saveAs(blob, fileName);
  }

  generateArray(obj) {
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  onChangeEntrevista(i: any) {
    // console.log(i);
  }

  copied(e: any) {
    this.toastr.info('Tag: ' + e.content + ' copiada');
  }
}
